/* Keep the native required select as the form value and no-JavaScript fallback. */
if (!customElements.get('kh-contact-select')) {
  customElements.define('kh-contact-select', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.select = this.querySelector('select');
      this.trigger = this.querySelector('[role="combobox"]');
      this.list = this.querySelector('[role="listbox"]');
      this.options = [...this.querySelectorAll('[role="option"]')];
      this.error = this.querySelector('.kh-contact__field-error');
      if (!this.select || !this.options.length) return;
      this.controller = new AbortController();
      const listen = (element, event, handler) => element.addEventListener(event, handler, { signal: this.controller.signal });
      this.select.hidden = true;
      this.select.tabIndex = -1;
      this.select.setAttribute('aria-hidden', 'true');
      this.trigger.hidden = false;
      this.sync();

      listen(this.trigger, 'click', () => this.setOpen(this.trigger.getAttribute('aria-expanded') !== 'true'));
      listen(this.trigger, 'keydown', (event) => this.onKeydown(event));
      listen(this.list, 'mousedown', (event) => event.preventDefault());
      listen(this.list, 'click', (event) => {
        const option = event.target.closest('[role="option"]');
        if (option) this.choose(this.options.indexOf(option));
      });
      listen(document, 'pointerdown', (event) => { if (!this.contains(event.target)) this.setOpen(false); });
      listen(this, 'focusout', (event) => { if (!this.contains(event.relatedTarget)) this.setOpen(false); });
      listen(this.select, 'change', () => this.sync());
      listen(this.select, 'invalid', (event) => {
        event.preventDefault();
        this.error.textContent = this.select.validationMessage;
        this.error.hidden = false;
        this.trigger.setAttribute('aria-invalid', 'true');
        this.trigger.setAttribute('aria-describedby', this.error.id);
        const firstInvalid = this.select.form.querySelector(':invalid');
        if (firstInvalid === this.select) this.trigger.focus();
      });
      if (this.select.form) listen(this.select.form, 'reset', () => requestAnimationFrame(() => { this.sync(); this.setOpen(false); }));
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    sync() {
      const selected = this.select.selectedOptions[0];
      this.trigger.querySelector('[data-contact-select-label]').textContent = selected?.textContent || '';
      this.trigger.classList.toggle('has-value', Boolean(this.select.value));
      this.options.forEach((option) => option.setAttribute('aria-selected', String(option.dataset.value === this.select.value)));
      this.error.hidden = true;
      this.trigger.removeAttribute('aria-invalid');
      this.trigger.removeAttribute('aria-describedby');
    }

    setOpen(open) {
      this.trigger.setAttribute('aria-expanded', String(open));
      this.list.hidden = !open;
      this.classList.toggle('is-open', open);
      if (open) this.activate(Math.max(0, this.options.findIndex((option) => option.dataset.value === this.select.value)));
      else this.trigger.removeAttribute('aria-activedescendant');
    }

    activate(index) {
      this.active = (index + this.options.length) % this.options.length;
      this.options.forEach((option, i) => option.classList.toggle('is-active', i === this.active));
      this.trigger.setAttribute('aria-activedescendant', this.options[this.active].id);
    }

    choose(index) {
      this.select.value = this.options[index].dataset.value;
      this.select.dispatchEvent(new Event('input', { bubbles: true }));
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
      this.setOpen(false);
      this.trigger.focus();
    }

    onKeydown(event) {
      const open = this.trigger.getAttribute('aria-expanded') === 'true';
      if (event.key === 'Tab') { this.setOpen(false); return; }
      if (event.key === 'Escape') { event.preventDefault(); this.setOpen(false); return; }
      if (['ArrowDown', 'ArrowUp', 'Home', 'End', 'Enter', ' '].includes(event.key)) {
        event.preventDefault();
        if (event.key === 'Enter' || event.key === ' ') {
          if (open) this.choose(this.active);
          else this.setOpen(true);
          return;
        }
        if (!open) this.setOpen(true);
        if (event.key === 'Home') this.activate(0);
        else if (event.key === 'End') this.activate(this.options.length - 1);
        else if (open) this.activate(this.active + (event.key === 'ArrowDown' ? 1 : -1));
        else if (event.key === 'ArrowUp') this.activate(this.options.length - 1);
      } else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        const now = Date.now();
        this.search = (now - (this.lastKeyTime || 0) < 600 ? this.search || '' : '') + event.key.toLowerCase();
        this.lastKeyTime = now;
        const index = this.options.findIndex((option) => option.textContent.trim().toLowerCase().startsWith(this.search));
        if (index >= 0) { this.setOpen(true); this.activate(index); }
      }
    }
  });
}

document.querySelectorAll('.kh-contact [data-contact-status]').forEach((status) => status.focus());
